import { Box, styled } from "@mui/material";
import { Blue200, Blue400, GRAYPALETITLE } from "../../../styles/color";

export const MeetingRoomTabsWrapper = styled(Box)(() => ({
  display: "flex",
  flex: 11,
  flexDirection: "column",
  width: "100%",
  border: `1px solid #DCDFE3`,
  borderRadius: "4px",
  padding: "8px",
}));

export const MeetingRoomTabsHeader = styled(Box)(() => ({
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
  marginBottom: "8px",
}));

export const ReservationButton = styled("button")(() => ({
  fontFamily: "Noto sans CJK KR",
  backgroundColor: "#ffffff",
  padding: "4px",
  fontSize: "0.875rem",
  height: "2rem",
  color: GRAYPALETITLE,
  border: "1px solid #DCDFE3",
  boxShadow: "none",
  borderRadius: "4px",
  fontWeight: 500,
  cursor: "pointer",
  overflow: "hidden",
  whiteSpace: "nowrap",
  "&:hover": {
    backgroundColor: Blue400, // 또는 Blue300, Blue500 등
    boxShadow: "none",
    color: "#ffffff",
  },
}));
